import React from "react";
import { Props, Screen } from "./types";

function useScreenWatcher() {
  const [screen, setScreen] = React.useState<Screen>({
    width: 0,
    height: 0,
  });

  React.useEffect(() => {
    const watchScreen = () =>
      setScreen({ height: window.innerHeight, width: window.innerWidth });

    window.addEventListener("resize", watchScreen);

    return () => window.removeEventListener("resize", watchScreen);
  }, [setScreen]);

  React.useEffect(() => {
    setScreen({ height: window.innerHeight, width: window.innerWidth });
  }, [setScreen]);

  return screen;
}

function ScreenWatcher(props: Props) {
  const screen = useScreenWatcher();

  return <React.Fragment>{props.renderChildren(screen)}</React.Fragment>;
}

export type { Screen };

export { ScreenWatcher, useScreenWatcher };
